export default (initialState: any) => {
  return initialState?.access || {};
};
